import { countWords } from '../wordCount';
import { normalizeName } from '../resolve';

const SECTION_WORD_LIMIT = 3000;

/**
 * Import definition for the abbreviations list on the Preliminaries page.
 * Target: planStore.content.preliminaries.abbreviations
 */
export const abbreviationsImport = {
  type: 'abbreviations',
  sheetName: 'Abbreviations',
  templateFileName: 'abbreviations-template.xlsx',
  noun: { singular: 'abbreviation', plural: 'abbreviations' },
  replaceWarning: 'Importing will replace all existing abbreviations in this plan, including any that were added manually.',

  columns: [
    { header: 'Abbreviation', key: 'abbreviation', required: true, type: 'string', width: 18 },
    { header: 'Full Name', key: 'fullName', required: true, type: 'string', width: 56 },
  ],

  previewColumns: [
    { key: 'abbreviation', label: 'Abbreviation' },
    { key: 'fullName', label: 'Full Name' },
  ],

  buildContext: () => ({}),

  validateRows: (rows, addError) => {
    const firstRowUsedAt = new Map();

    rows.forEach(({ excelRow, values }) => {
      if (!values.abbreviation) return;

      const key = normalizeName(values.abbreviation);

      if (firstRowUsedAt.has(key)) {
        addError(excelRow, 'Abbreviation', `Duplicate abbreviation "${values.abbreviation}" — first used on row ${firstRowUsedAt.get(key)}.`);
      } else {
        firstRowUsedAt.set(key, excelRow);
      }
    });
  },

  buildResult: (rows, context, nextId) => ({
    items: rows.map(({ values }) => ({
      id: nextId(),
      abbreviation: values.abbreviation,
      fullName: values.fullName,
    })),
  }),

  validateSectionLimit: (result, planStore) => {
    const wouldBeSection = { ...planStore.content.preliminaries, abbreviations: result.items };
    const words = countWords(wouldBeSection);

    if (words > SECTION_WORD_LIMIT) {
      return `This import would put the Preliminaries section over its ${SECTION_WORD_LIMIT}-word limit (${words} words). Reduce the content and try again.`;
    }

    return null;
  },

  previewRows: (result) => result.items,

  summarize: (result) => `${result.items.length} ${result.items.length === 1 ? 'abbreviation' : 'abbreviations'} ready to import`,

  commit: (planStore, result) => {
    planStore.content.preliminaries.abbreviations = [...result.items]
      .sort((a, b) => a.abbreviation.toLowerCase().localeCompare(b.abbreviation.toLowerCase()));
  },
};
